import React from 'react'
import { Button } from 'semantic-ui-react'

export const DeleteSurveyModal = ({ modal: Modal, close, onSubmit, loading }) => {
  return (
    <Modal size="tiny">
      <Modal.Header>Delete survey</Modal.Header>
      <Modal.Content>
        <p>Are you sure you wish to delete this survey? Once deleted, it cannot be recovered.</p>
        <p className=" italic">
          Note: All responses associated with this survey will be preserved and will not be deleted.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={onSubmit} disabled={loading} loading={loading} negative>
          Delete survey
        </Button>
      </Modal.Actions>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyItems/DeleteSurveyModal/index.js